
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/price",
      function () {
        return require("private-next-pages/price/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/price"])
      });
    }
  